module.exports = __webpack_public_path__ + "media/assets/cambiar-427b8cacfeefe94b88f4988f83f2544c.svg";